import { Skeleton } from '@/components/ui/skeleton';

export function ThreadDetailSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <div className="pt-24 pb-6 px-6 border-b border-border/50">
        <div className="container mx-auto max-w-4xl">
          <Skeleton className="h-4 w-32" />
        </div>
      </div>

      <main className="py-10 px-6">
        <div className="container mx-auto max-w-4xl">
          <div className="mb-10">
            <div className="flex items-center gap-2 mb-4">
              <Skeleton className="h-3 w-20" />
              <span className="text-muted-foreground/50">•</span>
              <Skeleton className="h-3 w-16" />
            </div>
            <Skeleton className="h-10 w-3/4 mb-4" />
            <Skeleton className="h-5 w-16 mb-4" />
            <div className="flex gap-1.5 mb-4">
              <Skeleton className="h-5 w-14 rounded-lg" />
              <Skeleton className="h-5 w-12 rounded-lg" />
              <Skeleton className="h-5 w-16 rounded-lg" />
            </div>
            <div className="flex flex-wrap items-center justify-between gap-4 py-5 border-y border-border/50">
              <div className="flex items-center gap-3">
                <Skeleton className="h-10 w-10 rounded-full" />
                <div>
                  <Skeleton className="h-4 w-24 mb-1" />
                  <Skeleton className="h-3 w-28" />
                </div>
              </div>
              <div className="flex items-center gap-5">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-3 w-16" />
              </div>
            </div>
          </div>

          <div className="space-y-3 mb-12">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-4/5" />
          </div>

          <div className="flex items-center gap-6 pb-10 border-b border-border/50 mb-10">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-20 rounded-xl" />
            <Skeleton className="h-8 w-20 rounded-xl" />
          </div>

          <div className="space-y-8">
            <Skeleton className="h-4 w-32" />
            <div className="space-y-6">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex gap-4">
                  <Skeleton className="h-9 w-9 rounded-full flex-shrink-0" />
                  <div className="flex-1 space-y-2">
                    <div className="flex justify-between">
                      <Skeleton className="h-4 w-24" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-2/3" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
